import React from "react";

const CoreValues = () => {
  const values = [
    {
      image: "/images/Commitment-to Quality-Reliability.png",
      title: "Commitment to Quality & Reliability",
      description:
        "At Trolift, we believe quality isn’t just about how a product looks — it’s about how it performs, every single time. From precise engineering to durable materials, every ladder, trolley, and pallet truck we build stands for reliability and long-term value. Our goal is simple — to deliver performance you can trust.",
      bgColor: "bg-blue-50",
    },
    {
      image: "/images/Customer-Centric Approach.png",
      title: "Customer-Centric Approach",
      description:
        "Our customers are at the heart of everything we do. We take the time to understand their challenges and create practical, efficient solutions that make their work safer and easier. With a strong customer-first mindset, we aim to exceed expectations through honesty, responsiveness, and lasting relationships.",
      bgColor: "bg-red-50",
    },
    {
      image: "/images/Integrity-Continuous-Improvement.png",
      title: "Integrity & Continuous Improvement",
      description:
        "We operate with integrity in every decision we make — staying true to our word, transparent in our actions, and respectful in our relationships. Guided by industry experience and forward-thinking leadership, we embrace continuous improvement, constantly innovating to deliver greater value to our customers and partners.",
      bgColor: "bg-yellow-50",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-catalina-blue text-center mb-12">
          Our Core Values
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className={`${value.bgColor} p-8 rounded-lg text-center hover:shadow-lg transition duration-300`}
            >
              {value.image && (
                <div className="flex justify-center mb-4">
                  <img
                    src={value.image}
                    alt={value.title}
                    className="w-48 h-48 object-contain rounded-lg"
                  />
                </div>
              )}
              <h3 className="text-2xl font-bold text-catalina-blue mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
